# localisation for the user preferences and the error pages
window.$ = window.jQuery = require "jquery"
## Shims
require './components/common/MomentWrapper/MomentWrapper'
guruLocalisation = require './components/common/services/localization/guruLocalisation'
guruLocalisation.localise KV.initialNamespaces || ['additional']
